import { Component, Optional, Input, Output, EventEmitter } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ModalController,
  ViewController
} from 'ionic-angular';
import { HomeFeedProvider } from '../../../../shared/nestjs/home-feed/home-feed';
import { SFGOAuthService } from '../../../../providers/sfgoauth.service/sfgoauth.service';
@IonicPage()
@Component({
  selector: 'gd-teammates',
  templateUrl: 'gd-teammates.html',
})
export class GdTeammatesPage {

  @Output() getSPV: any = new EventEmitter();
  @Output() getSPVDetail: any = new EventEmitter();
  @Input() funcTask: boolean = false;

  isShow: boolean = false;
  Supervisor: any = [];
  teammates: any = [];
  limit: number;

  // pagging
  bodySubOrdinate = { skip: 0, limit: 8 }
  bodyCoWorker = { skip: 0, limit: 8 }
  bodyFavorite = { skip: 0, limit: 7, isEnable: true }

  // subordinat
  teamSubordinate: any = [];
  pageSubordinate: number = 1;
  totalPageSubordinate: number = 1;

  // supervisor
  teamSupervisor: any = [];

  // getCoWorkers
  teamCoWorker: any = [];
  pageCoworker: number = 1;
  totalPageCoWorker: number = 1;

  // favourite
  teamFavourite: any = [];
  pageFavourite: number = 1;
  totalPageFavourite: number = 1;

  toggle: boolean = false;
  currentSPV: any;

  toggleModal: boolean = false;
  tasknFeedBack: boolean = false;

  skeletonSpv: boolean = true;
  skeletonSubordinat: boolean = true;
  skeletonCoworker: boolean = true;
  skeletonFav: boolean = true;

  dummyLocked: boolean = false;
  toggleLocked: boolean = false;

  showFavourite: boolean = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public homeFeedProvider: HomeFeedProvider,
    @Optional()
    public viewCtrl: ViewController,
    public sfgoAuthService: SFGOAuthService
  ) {
    this.limit = 8;
    this.tasknFeedBack = navParams.get('tasknFeedBack');
  }

  showLocked() {
    if (this.dummyLocked) {
      this.toggleLocked = true;
      setTimeout(() => {
        this.toggleLocked = false;
      }, 15000);
    }
  }

  async ionViewDidLoad() {

  }

  async ionViewWillEnter() {
    console.log("wilenter")
    this.getSubordinate();
    this.getSupervisor();
    this.getCoWorker();
    const auth = await this.sfgoAuthService.getAuthorization();
    console.log(auth.menu["team-mates-favorite"]);
    this.showFavourite = (auth.menu["team-mates-favorite"]) ? auth.menu["team-mates-favorite"] : false;
    if (this.showFavourite) {
      this.getFavourite();
    }
  }

  getCoWorker(): Promise<any> {
    return new Promise((resolve) => {
      this.homeFeedProvider.getCoWorkers(this.bodyCoWorker)
        .subscribe(result => {
          this.pageCoworker = result.page;
          this.totalPageCoWorker = result.totalPage;
          if (this.totalPageCoWorker < 1) {
            this.totalPageCoWorker = 1;
          }
          this.teamCoWorker = result.data;
          this.skeletonCoworker = false;
          resolve();
        }, error => {
          this.skeletonCoworker = false;
          this.dummyLocked = true;
          if (error.status == '404') {
            this.toggleLocked = true;
            this.showLocked();
          }
          resolve();
        }
        )
    });
  }

  getSupervisor(): Promise<any> {
    return new Promise((resolve) => {
      this.homeFeedProvider.getSupervisor()
        .subscribe(result => {
          if (result.data != null) {
            this.teamSupervisor = [result.data];
            this.getSPVDetail.emit(result.data);
          }
          this.skeletonSpv = false;
          resolve();
        }, error => {
          this.dummyLocked = true;
          this.skeletonSpv = false;
          if (error.status == '404') {
            this.toggleLocked = true;
            this.showLocked();
          }
          resolve();
        }
        )
    })
  }

  getSubordinate(): Promise<any> {
    return new Promise((resolve) => {
      this.homeFeedProvider.getSubordinate(this.bodySubOrdinate)
        .subscribe(
          result => {
            result.data.forEach(element => {
              this.currentSPV = element.spvParent;
            });
            this.getSPV.emit(this.currentSPV);
            this.pageSubordinate = result.page;
            this.totalPageSubordinate = result.totalPage;
            if (this.totalPageSubordinate < 1) {
              this.totalPageSubordinate = 1;
            }
            this.teamSubordinate = result.data;
            this.skeletonSubordinat = false;
            resolve();
          }, error => {
            this.dummyLocked = true;
            this.skeletonSubordinat = false;
            if (error.status == '404') {
              this.toggleLocked = true;
              this.showLocked();
            }
            resolve();
          }
        )
    })
  }

  getFavourite(): Promise<any> {
    return new Promise((resolve) => {
      this.homeFeedProvider.getAllFavorite(this.bodyFavorite)
        .subscribe(result => {
          this.teamFavourite = result.data;
          this.pageFavourite = result.page;
          this.totalPageFavourite = result.totalPage;
          if (this.totalPageFavourite < 1) {
            this.totalPageFavourite = 1;
          }
          this.skeletonFav = false;
          resolve();
        }, error => {
          this.dummyLocked = true;
          this.skeletonFav = false;
          if (error.status == '404') {
            this.toggleLocked = true;
            this.showLocked();
          }
          resolve();
        })
    })
  }

  openQuickTask(team, i, sendTo) {
    if ((this.tasknFeedBack != null && this.tasknFeedBack == false) || !this.funcTask) {
      this.navCtrl.push('ProfileHomePage', {
        empid: sendTo.viewGoEmp ? sendTo.viewGoEmp.empId : sendTo.empId,
        userId: sendTo.viewGoEmp ? sendTo.viewGoEmp.userId : sendTo.userId,
      });
    } else {
      if (!this.toggleModal) {
        this.toggleModal = true;
        if (team == 'favorite') {
          sendTo = sendTo.viewGoEmp;
          sendTo.tgospempfavorite = 1;
        }
        let last = document.querySelectorAll("." + team + "-" + i).length;
        // let section = document.querySelector("." + team +"-" + i).getBoundingClientRect();
        let section = document.querySelectorAll("." + team + "-" + i)[last - 1].getBoundingClientRect();
        // console.log(section, ' sectionnya')
        console.log(section, ' sectionznya')
        console.log(last, ' lastnya')
        let modal = this.modalCtrl.create('QuickTaskPage', {
          mode: 'desktop',
          top: section.top,
          bottom: section.bottom,
          left: section.left,
          data: sendTo
        }, { cssClass: "grd-modal-noanimation" });
        modal.onDidDismiss((openNewTask) => {
          this.getSubordinate();
          this.getSupervisor();
          this.getCoWorker();
          this.getFavourite();
          this.toggleModal = false;
          if (openNewTask) {
            this.navCtrl.push("NewTaskPage", {
              dataTask: true
            });
          }
        })
        modal.present();
      }
    }
  }

  goToFav() {
    this.navCtrl.push('SearchAllEmployeePage');
  }

  close() {
    if (this.viewCtrl) this.viewCtrl.dismiss();
  }

  prevPage(section) {
    if (section == 'subordinate') {
      if (this.bodySubOrdinate.skip >= this.bodySubOrdinate.limit) {
        this.bodySubOrdinate.skip -= this.bodySubOrdinate.limit;
        this.getSubordinate();
      }
    } else if (section == 'coworker') {
      if (this.bodyCoWorker.skip >= this.bodyCoWorker.limit) {
        this.bodyCoWorker.skip -= this.bodyCoWorker.limit;
        this.getCoWorker();
      }
    }
    else if (section == 'favourite') {
      if (this.bodyFavorite.skip >= this.bodyFavorite.limit) {
        this.bodyFavorite.skip -= this.bodyFavorite.limit;
        this.getFavourite();
      }
    }
  }

  nextPage(section) {
    console.log('section', section)
    if (section == 'subordinate') {
      if (this.teamSubordinate.length == this.bodySubOrdinate.limit) {
        this.bodySubOrdinate.skip += this.bodySubOrdinate.limit;
        this.getSubordinate();
      }
    } else if (section == 'coworker') {
      if (this.teamCoWorker.length == this.bodyCoWorker.limit) {
        this.bodyCoWorker.skip += this.bodyCoWorker.limit;
        this.getCoWorker();
      }
    } else if (section == 'favourite') {
      if (this.teamFavourite.length == this.bodyFavorite.limit) {
        this.bodyFavorite.skip += this.bodyFavorite.limit;
        this.getFavourite();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/general/home2/gd-teammates/gd-teammates.ts